import * as React from "react";
import {animated } from "react-spring";
import {Header} from "./Header";
import {DialogProps} from "./Dialog";
import {Footer} from "./Footer";
import {Content} from "./Content";
import {ReactUtilities} from "shared/utilities/react/ReactUtilities";
import {Spring} from "react-spring/renderprops";

export class DialogContainer extends React.Component<DialogProps, DialogContainerState> {
    static OpenDialogsCount:number=0;
    static InitialZIndex:number=100000;
    static defaultProps: Partial<DialogProps> = {
        IsOpen:false
    };

    constructor(props: DialogProps, context?: any) {
        super(props, context);
        this.state = {
            IsOpen:this.props.IsOpen,
            Status:this.props.IsOpen?"Opening":'Rest'
        };

        if(this.state.IsOpen)
            DialogContainer.OpenDialogsCount++;
    }


    componentWillReceiveProps(nextProps: Readonly<DialogProps>, nextContext: any): void {
        if(nextProps.IsOpen!=this.state.IsOpen) {
            if(nextProps.IsOpen)
            {
                DialogContainer.OpenDialogsCount++;
            }
            this.setState({IsOpen: nextProps.IsOpen, Status: nextProps.IsOpen ? "Opening" : "Closing"});
            if(!nextProps.IsOpen)
                ReactUtilities.ExecuteMethodPropIfDefined(this.props.OnClose);
        }
    }

    public render() {
        let fromBackdrop:any={};
        let toBackdrop:any={};


        let fromModal:any={};
        let toModal:any={};
        if(this.state.Status=="Opening")
        {
            fromBackdrop={
                opacity:0
            };

            toBackdrop={
                opacity:1
            };

            fromModal={
                transform:'translateY(-200px) translateX(-50%)',
                opacity:0

            };

            toModal={
                transform:'translateY(40px) translateX(-50%)',
                opacity:1
            };


        }
        if(this.state.Status=='Closing')
        {
            toBackdrop={
                opacity:0
            };

            toModal={
                transform:'translateY(-200px) translateX(-50%)',
                opacity:0
            }
        }


        let content=(
            <Content style={this.props.ContentStyles}>
                {this.props.children}
            </Content>
        );
        let header=this.CreateHeader();
        let footer=this.CreateFooter();
        return (
            <React.Fragment>

                <Spring  config={{precision:.09}} immediate={this.state.Status=="Rest"} from={fromBackdrop} to={toBackdrop} onRest={()=>{if(this.state.Status=='Closing'){ReactUtilities.ExecuteMethodPropIfDefined(this.props.OnClose);this.setState({Status:"Rest"}); ReactUtilities.ExecuteMethodPropIfDefined(this.props.AfterOnClose);}}} >

                    {styles=>{ return(
                            <div style={{...styles,display:(this.state.IsOpen||this.state.Status!="Rest"?'block':'none'),zIndex:DialogContainer.InitialZIndex*Math.max(DialogContainer.OpenDialogsCount,1)}} className={'rnBackDrop rnShow'}/>
                    )}}
                </Spring>

                <Spring config={{precision:.09}}   immediate={this.state.Status=="Rest"}  from={fromModal} to={toModal} >
                    {(styles:any)=>{

                        /*    let translateY;
                            if(styles.transform<0)
                                styles.transform='translateY('+styles.transform+'%)';
                            else
                                styles.transform='translateY('+styles.transform+'px)';

                            styles.transform=styles.transform+' '+'translateX(-50%)';*/
                        return(

                            <div className={'rnModal rednao'} style={{...this.props.Styles, ...styles,display:(this.state.IsOpen||this.state.Status!="Rest"?'block':'none'),zIndex:1+DialogContainer.InitialZIndex*Math.max(DialogContainer.OpenDialogsCount,1)}} >
                                <React.Fragment>
                                    {header}
                                    {content}
                                    {footer}
                                </React.Fragment>

                            </div>
                        )}}
                </Spring>
            </React.Fragment>




        )
    }

    private CreateFooter(){
        return(
            <Footer FooterArea={this.props.FooterArea} IsBusy={this.props.IsBusy} EnableApply={this.props.EnableApply} EnableCancel={this.props.EnableCancel} OnCancel={()=>this.Close()} OnApply={this.props.OnApply} ApplyButtonIcon={this.props.ApplyIcon} ApplyButtonText={this.props.ApplyTitle} CancelButtonIcon={this.props.CancelIcon} CancelButtonText={this.props.CancelTitle}/>
        )
    }

    public Close(){

        DialogContainer.OpenDialogsCount--;
        DialogContainer.OpenDialogsCount=Math.max(0,DialogContainer.OpenDialogsCount);
        this.setState({IsOpen:false,Status:'Closing'});


    }
    private CreateHeader() {
        return (
            <Header Icon={this.props.Icon} Title={this.props.Title} onClick={()=>{this.Close()}}/>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------


interface DialogContainerState {
    IsOpen:boolean;
    Status:"Opening"|'Closing'|'Rest';
}



//#endregion "My Region"